"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Password = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const VisibilityOff_1 = require("@nbc-design/icons/lib/web/VisibilityOff");
const VisibilityOn_1 = require("@nbc-design/icons/lib/web/VisibilityOn");
const input_1 = require("@nbc-design/input");
require("./password.css");
/** This component is used to display a password input with a button that collapse the visibility of the password in the input. It's an extended input.*/
exports.Password = React.forwardRef(({ id, name, className, dataTest, disabled = false, timeout = 0, ariaLabelShow, ariaLabelHide, length, ...other }, ref) => {
    const [visibility, setVisibility] = React.useState(false);
    const [timeoutId, setTimeoutID] = React.useState(0);
    const classes = (0, classnames_1.default)('dsc-password', length && `is-${length}`, className);
    let timeoutAutoId = 0;
    const toggleVisibility = () => {
        if (!visibility) {
            setVisibility(true);
            if (timeout) {
                timeoutAutoId = window.setTimeout(() => {
                    setVisibility(false);
                }, timeout);
                setTimeoutID(timeoutAutoId);
            }
        }
        else {
            setVisibility(false);
            if (timeout) {
                clearTimeout(timeoutId);
                setTimeoutID(0);
            }
        }
    };
    const iconProps = {
        className: 'dsc-password__icon',
        size: 'medium',
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes, "data-test": dataTest || name, children: [(0, jsx_runtime_1.jsx)(input_1.Input, { ...other, className: "dsc-password__input", id: id, name: name, type: visibility ? 'text' : 'password', dataTest: "input", disabled: disabled, ref: ref }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "dsc-password__btn", onClick: toggleVisibility, disabled: disabled, children: visibility ? ((0, jsx_runtime_1.jsx)(VisibilityOff_1.VisibilityOff, { className: "dsc-password__icon", size: "medium", title: ariaLabelHide })) : ((0, jsx_runtime_1.jsx)(VisibilityOn_1.VisibilityOn, { ...iconProps, title: ariaLabelShow })) })] }));
});
exports.Password.displayName = 'Password';
//# sourceMappingURL=password.js.map